import { createContext } from 'react';
import { UserAddress } from '@src/@types/addresses';

export const SelfContext = createContext<UserAddress>({} as UserAddress);
